import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            内容分类
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            六大内容板块，满足你的多元阅读需求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-lg border border-background-200/70 p-6 hover:border-accent-200 transition-colors cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-100 text-accent-500 mb-4 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors">
                <i className={`${cat.icon} text-lg`} />
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}